import { BRAND_NAME } from "@kmstories/shared";
import { useT } from "../i18n/LocaleProvider.js";

/**
 * The bilingual wordmark: "QISSAKHANA" in the grotesque and the Persian name
 * beneath, both underlined by one saffron thread. Both scripts are always
 * visible regardless of locale: the pair says the same name twice. In English
 * the tagline "House of Stories" sits under the thread; in Persian the name
 * already means that, so the bundle leaves the tagline empty and nothing renders.
 * Pure markup + CSS so it recolours with tokens.
 */
export function Lockup({ compact = false, hero = false }: { compact?: boolean; hero?: boolean }) {
  const { m } = useT();
  return (
    <span className={`lockup ${compact ? "lockup--compact" : ""} ${hero ? "lockup--hero" : ""}`.trim()}>
      <span className="lockup__latin" lang="en">
        {BRAND_NAME}
      </span>
      <span className="lockup__fa" lang="fa" dir="rtl">
        {m.meta.siteNameFa}
      </span>
      <span className="lockup__thread" aria-hidden="true" />
      {m.meta.brandTagline && (
        <span className="lockup__tagline" lang="en">
          {m.meta.brandTagline}
        </span>
      )}
    </span>
  );
}
